module.exports = __webpack_public_path__ + "img/scroll.7e863187.png";